import http from '../http'
// 根据vipCode查询VIP会员-CMS配置表
export function mapCmsVipConfigByVipCode(params) {
  return http({
    url: `/api/cms/openwebsite/mapCmsVipConfigByVipCode`,
    method: 'get',
    params,
    loading: false
  })
}



// WEBPACK FOOTER //
// ./src/api/vip/configApi.js